import React from 'react'
import { Box, Chip, Tooltip } from '@mui/material'
import { useSmartTranslation } from '../../hooks/useSmartTranslation'
import { AVAILABILITY_COLOR, AVAILABILITY_TEXT, OUTCOME_TEXT, PROBLEM_TEXT, textOf } from './labelPrintingTexts'

// Historia 226 (S31, S124): availability of a printer as a coloured chip; when it is not available, the tooltip gives
// the translated reason and problems. Shared by the printers list and the print dialog's selector.
const PrinterStatusChip = ({ availability, availabilityReason = '', availabilityProblems = [] }) => {
  const { t_ } = useSmartTranslation()
  const chip = (
    <Chip
      size='small'
      color={AVAILABILITY_COLOR[availability] || 'default'}
      label={t_(textOf(AVAILABILITY_TEXT, availability))}
    />
  )
  if (availability !== 'UNAVAILABLE' || !availabilityReason) return chip

  const title = (
    <Box>
      <div>{t_(textOf(OUTCOME_TEXT, availabilityReason))}</div>
      {availabilityProblems.map((problem) => <div key={problem}>{t_(textOf(PROBLEM_TEXT, problem))}</div>)}
    </Box>
  )
  return <Tooltip title={title}><span>{chip}</span></Tooltip>
}

export default PrinterStatusChip
